import HintIcon from '@images/icons/hint_select_role_icon.svg?react'
import { tr, useMatchMedia } from 'mmfintech-commons'
import ReactTooltip from 'react-tooltip'

import './createExpensesMatrixTooltip.scss'

const preparedToolTip = () => `
 <div>
   ${tr(
     'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE1',
     'Users with approval permissions assigned in User Management must be added here to be included in the department’s approval flow.'
   )} <br/><br/>




  <li> ${tr(
    'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE2',
    'You can add up to five approvers, with approvals following a hierarchy.'
  )} <br/> <br/>
   <li> ${tr(
     'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE3',
     'Thresholds can also be set at each level for enhanced customization.'
   )} <br/> <br/>
   <li> ${tr(
     'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE4',
     'The Final Approver will always make the last decision before payment.'
   )} <br/><br/>
    <li> ${tr(
      'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE5',
      'If a user is missing from the list, ensure they have been granted approval permissions in User Management.'
    )} <br/><br/>
    <li> ${tr(
      'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE6',
      'You can assign up to two Final Approvers at the same level—approval from either one is sufficient.'
    )} <br/><br/>
    <li> ${tr(
      'FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_MATRIX_TOOLTIP.LINE7',
      'Anyone with access to funds can initiate a payment after approval, provided they have the necessary permissions to do so.'
    )} <br/><br/>

  
 <div/>
`

export const CreateExpensesMatrixTooltip = () => {
  const isMobile = useMatchMedia({ breakpoint: 768, prefix: 'max' })

  return (
    <>
      <span data-for='create-matrix-tooltip' data-tip={preparedToolTip()}>
        <HintIcon />
      </span>
      <ReactTooltip
        id='create-matrix-tooltip'
        place={isMobile ? 'right' : 'bottom'}
        html
        type='dark'
        arrowColor='transparent'
        className='create-matrix-tooltip'
        padding={isMobile ? '12px' : '24px'}
      />
    </>
  )
}
